import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Breadcrumb from "src/components/layouts/Common/Breadcrumb";
import Sidebar from "src/components/layouts/sidebar/Sidebar";
import Participation from "src/components/panel/participation/Participation";

const ParticipationView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("participation_list_tab")}</title>
      </Helmet>
      <Sidebar>
        <Breadcrumb
          title={t("participation_list_title")}
          subtitle={t("participation_list_subtitle")}
        />
        <Participation />
      </Sidebar>
    </>
  );
};

export default ParticipationView;
